import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooRouter from "aldoo-ra/Router"

function Page() {
  const pageContext = usePageContext()
  const urlPathname = pageContext.urlPathname
  const Component = AldooRouter.resolve(urlPathname)
  
  if (!Component) {
    // If no component found, resolve the /404 route instead
    const NotFoundComponent = AldooRouter.resolve("/404")
    if (NotFoundComponent) {
      return <NotFoundComponent pageContext={pageContext} />
    }
    // Fallback if even /404 route doesn't exist
    return <div>404 - Page not found</div>
  }
  
  return <Component pageContext={pageContext} />
}

export default Page